/*
 * AppModal — 项目统一 Modal 封装（design-spec §10.1）
 * 规范：三档宽度 / closable / destroyOnClose / 主操作右取消左 / 圆角 16
 */
import React from 'react';
import { Modal } from 'antd';
import type { ModalProps } from 'antd';

export type AppModalSize = 'sm' | 'md' | 'lg';

const SIZE_WIDTH: Record<AppModalSize, number> = {
  sm: 480,
  md: 600,
  lg: 880,
};

export interface AppModalProps extends Omit<ModalProps, 'width'> {
  /** 三档宽度：sm 480 / md 600 / lg 880 */
  size?: AppModalSize;
  /** 自定义 width 时不走 size（特殊场景） */
  width?: number;
  /** 危险操作（删除、清空等）：主按钮 danger */
  danger?: boolean;
}

const AppModal: React.FC<AppModalProps> = ({
  size = 'md',
  width,
  danger,
  okType,
  okText = '确定',
  cancelText = '取消',
  maskClosable = false,
  centered = true,
  ...rest
}) => {
  // antd v6 用 destroyOnHidden，旧版用 destroyOnClose；同时透传以兼容
  const destroyProps: any = { destroyOnClose: true, destroyOnHidden: true };
  return (
    <Modal
      width={width ?? SIZE_WIDTH[size]}
      okText={okText}
      cancelText={cancelText}
      okType={danger ? 'danger' : okType}
      maskClosable={maskClosable}
      centered={centered}
      {...destroyProps}
      {...rest}
    />
  );
};

export default AppModal;
